export default "__VITE_ASSET__DZHdw32m__"